module.exports = __webpack_public_path__ + "static/music-dd29756e8e1cb094601d0fce516daf66.svg";